<template>
    <div class="article-catalog">
        <p
           v-if="newIsShowMenu"
           class="btn-menu"
           @click="handleShow"
        >
            <span class="iconfont icon-caidan1"></span>
        </p>
        <p class="title-box">
            <span class="title">{{isTeachArticle?'教材章节目录':'选择知识点'}}</span>
            <i  class="el-dialog__close el-icon el-icon-close"
                @click="newIsArticleCatalog=false"></i>
        </p>
        <p
            v-if="isWarn"
            class="warn">
                <span class="el-icon-warning"></span>
            请先选择学科
        </p>
        <div class="tree-box">
            <div class="opt-box">
                <el-select
                        v-if="isTeachArticle"
                        class="input-box"
                        v-model="newCatalogId"
                        :clearable="true"
                        :disabled="disabled"
                        placeholder="请选择"
                        @focus="setSendKeyBoardToCocos({key: `onAttrSelect`, value: false})"
                        @blur="setSendKeyBoardToCocos({key: `onAttrSelect`, value: true})"
                        @change="publisherSelected"
                >
                    <el-option
                            v-for="item in newForm[0].options"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                    </el-option>
                </el-select>
                <el-input
                        v-else
                        class="input-box"
                        v-model="newForm[0].value"
                        :disabled="disabled"
                        :clearable="true"
                        placeholder="请输入知识点"
                        @focus="setSendKeyBoardToCocos({key: `onAttrInput`, value: false})"
                        @blur="setSendKeyBoardToCocos({key: `onAttrInput`, value: true})"
                        @input="knowledgeInput"
                ></el-input>
            </div>
            <!--<element-form-->
                <!--class="txts"-->
                <!--:form.sync="newForm"-->
                <!--@onAttr="onAttr"-->
                <!--@onFocus="onFocus"-->
                <!--@onBlur="onBlur"-->
            <!--/>-->
            <el-tree
                    class="tree"
                    ref="tree"
                    :data="treeData"
                    node-key="key"
                    :default-expanded-keys="defaultKeys"
                    :props="{
                        children: 'children',
                        label: 'value'
                      }"
                    @node-click="handleNodeClick"
            >
                    <span class="custom-tree-node"  slot-scope="{ node, data }">
                        <el-tooltip class="item" effect="dark" :content="node.label" placement="right">
                          <span class="label">{{ node.label }}</span>
                        </el-tooltip>
                    </span>
            </el-tree>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {fields, fields2} from './fields'
    import * as CommonServer from '../../../../../../../../api/common'
    export default {
        name: "article-catalog",
        props: {
            catalog_id: [String, Number],
            subject_id: [String, Number],
            grade_id: [String, Number],
            unitSelectedParents: Array,
            chapter_id: [String, Number],
            knowledge_id: [String, Number],
            isShowMenu: Boolean, // 是否展示 缩略展开小图标
            isArticleCatalog: Boolean,
            type: String, // 类型
            navCatalogName: String,
            unitName: String
        },
        computed: {
            // 教材章节中 未选学科提示警告
            isWarn(){
                return this.isArticleCatalog && !this.subject_id
            },
            // 是否教材章节
            isTeachArticle(){
                return this.$enums.articleTypeEmum.teach === this.type
            }
        },
        watch:{
            isTeachArticle(){
                this.clearNavAll()
            },
            grade_id: {
                handler(newValue, oldValue){
                    if(newValue!==oldValue){
                        this.clearNavAll()
                    }
                    this.init()
                },
                deep: true,
                immediate: true
            },
            subject_id: {
                handler(newValue, oldValue){
                    if(newValue!==oldValue){
                        this.clearNavAll()
                    }
                    // 1.教材章节
                    // 1.1刷新选项
                    // 1.2刷新出版列表
                    // 2.更新知识点列表
                    this.init()
                },
                deep: true,
                immediate: true
            },
            unitSelectedParents(vl){this.newUnitSelectedParents = vl},
            newUnitSelectedParents:{
                handler(vl) {
                    this.$emit('update:unitSelectedParents', vl)
                    if(vl && vl.length){
                        const arr = this.newUnitSelectedParents.map(v=>v.key)
                        arr.pop()
                        this.defaultKeys = arr
                    }
                },
                deep: true,
                immediate: true
            },
            navCatalogName(vl){this.newNavCatalogName = vl},
            newNavCatalogName(vl){this.$emit('update:navCatalogName', vl)},
            unitName(vl){this.newUnitName = vl},
            newUnitName(vl){this.$emit('update:unitName', vl)},
            chapter_id(vl){this.newChapterId = vl},
            newChapterId(vl){this.$emit('update:chapter_id', vl)},
            catalog_id(vl){this.newCatalogId = vl},
            newCatalogId(vl){this.$emit('update:catalog_id', vl)},
            knowledge_id(vl){this.newKnowledgeId = vl},
            newKnowledgeId(vl){this.$emit('update:knowledge_id', vl)},
            isShowMenu(vl){this.newIsShowMenu = vl},
            newIsShowMenu(vl){this.$emit('update:isShowMenu', vl)},
            isArticleCatalog(vl){
                this.newIsArticleCatalog = vl
            },
            newIsArticleCatalog(vl){this.$emit('update:isArticleCatalog', vl)},
            type(){
                this.init()
            }
        },
        created(){
            this.$nextTick(()=>{
                this.init()
                // window.setNewKey = this.setNewKey
            })
        },
        data(){
            return {
                initial: false,
                disabled: false,
                defaultKeys: [], // 默认选中
                newNavCatalogName: this.navCatalogName, // 选中的教材版本名称
                newUnitSelectedParents: [], // 单元选中的所有父类
                newUnitName: this.unitName, // 选中的单元名称
                newIsShowMenu: this.isShowMenu,
                newIsArticleCatalog: this.isArticleCatalog,
                treeData: [],
                newForm: this.$_.cloneDeepWith(fields),
                tempKnowledge: null, // 知识列表缓存
                newCatalogId: this.catalog_id, // 教材章节目录
                newChapterId: this.chapter_id, // 章节选择
                newKnowledgeId: this.knowledge_id // 知识点选择
            }
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos']),
            init(){
                // this.clearNavAll()
                if(this.$enums.articleTypeEmum.teach === this.type){
                    this.newForm = this.$_.cloneDeepWith(fields)
                    this.treeData = []
                    // 教材章节
                    this.flushPublishers()
                }else if(this.$enums.articleTypeEmum.known === this.type){
                    this.newForm = this.$_.cloneDeepWith(fields2)
                    // 知识点
                    this.flushKnowledge()
                }
                this.flushSelect()
            },
            // 获取整颗数的 当前父节点们
            getParentNode(data2, nodeId2) {
                let arrRes = [];
                if (data2.length == 0) {
                    if (nodeId2) {
                        arrRes.unshift(data2)
                    }
                    return arrRes;
                }
                let rev = (data, nodeId) => {
                    for (let i = 0, length = data.length; i < length; i++) {
                        let node = data[i];
                        if (node.key == nodeId) {
                            arrRes.unshift(node)
                            rev(data2, node.parent_id);
                            break;
                        } else {
                            if (node.children) {
                                node.children.map(v=>v.parent_id = node.key)
                                rev(node.children, nodeId);
                            }
                        }
                    }
                    return arrRes;
                };
                arrRes = rev(data2, nodeId2);
                return arrRes;
            },
            // 初始化选项 || 刷新选项
            flushSelect(){
                try {
                    if(!this.subject_id){
                        this.disabled = true
                        this.treeData = []
                        this.tempKnowledge = null
                    } else{
                        this.disabled = false
                    }
                } catch (e) {
                    console.log('flushSelect==>', e)
                }
            },
            // 刷新出版列表
            async flushPublishers(){
                if(this.isTeachArticle && this.subject_id) {
                    try {
                        const res = await CommonServer.default.queryPublishers({
                            subject_id: this.subject_id,
                            grade_id: this.grade_id
                        })
                        const selectIndex = this.$utils.getIndexByAttr({attr: 'select', data: this.newForm})
                        if (selectIndex === -1) return false
                        let newData = res.data.map(v => {
                            return {
                                key: `${v.id}`,
                                value: v.name
                            }
                        })
                        // 如果列表无数据，则默认存在一个全部选项
                        if(newData && newData.length === 0){
                            newData = [
                                {
                                    key: 'all',
                                    value: '全部'
                                }
                            ]
                        }
                        this.newForm[selectIndex].options = newData

                        // 默认选中第一个
                        if(newData && newData[0] && newData[0].key) {
                            const key = this.catalog_id || newData[0].key
                            this.newForm[selectIndex].value = key
                            this.onAttr({
                                attr: 'select'
                            }, key)
                        }
                    } catch (e) {
                        console.log('flushPublishers==>', e)
                    }
                }
            },
            // 刷新知识点列表
            async flushKnowledge(){
                if(!this.isTeachArticle && this.subject_id) {
                    try {
                        const res = await CommonServer.default.queryKnowledge({
                            subject_id: this.subject_id,
                            grade_id: this.grade_id
                        })
                        // const treeIndex = this.$utils.getIndexByAttr({attr: 'tree', data: this.newForm})
                        // if (treeIndex === -1) return false
                        let arr = res.data.map(v=>{
                            return {
                                key: v.id,
                                value: v.name
                            }
                        })
                        // this.newForm[treeIndex].props.data = arr

                        // 如果列表无数据，则默认存在一个全部选项
                        if(arr && arr.length === 0){
                            arr = [
                                {
                                    key: 'all',
                                    value: '全部'
                                }
                            ]
                        }
                        this.treeData = arr
                        this.tempKnowledge = arr

                        this.setCurrentKey()
                    } catch (e) {
                        console.log('flushKnowledge==>', e)
                    }
                }
            },
            async onAttr(item, target, index){
                console.log('onAttr==>', item, target, index)

                const selectIndex = this.$utils.getIndexByAttr({attr: 'select', data: this.newForm})
                // const treeIndex = this.$utils.getIndexByAttr({attr: 'tree', data: this.newForm})
                switch (item.attr) {
                    case 'select': {
                        if(this.isTeachArticle) {
                            if(this.newCatalogId) {
                                this.newForm[selectIndex].value = target || this.newCatalogId
                            }
                            const pub_id = this.newForm[selectIndex].value
                            if (!pub_id) {
                                // this.newForm[treeIndex].props.data = []
                                this.treeData = [
                                    {
                                        key: 'all',
                                        value: '全部'
                                    }
                                ]
                                this.newChapterId = ''
                                this.newCatalogId = ''
                                return false
                            }
                            this.newCatalogId = target
                            // 获取书名列表
                            const booksList = await CommonServer.default.queryBooks({
                                subject_id: this.subject_id,
                                grade_id: this.grade_id,
                                publisher_id: pub_id
                            })
                            const books = booksList.data.map(v=>{
                                return {
                                    key: `${v.id}`,
                                    value: v.book_name,
                                    children: []
                                }
                            })
                            // this.treeData = arr
                            // console.log(booksList)
                            // debugger
                            const res = await CommonServer.default.queryUnits({
                                subject_id: this.subject_id,
                                pub_id,
                                with_chapters: 1 // 是否加载章节
                            })
                            // 1.重新组装单元节点 章节+单元
                            // 2.将章节和单元 挂在书籍下面
                            // 3.给整颗数每个节点设置唯一值
                            const units = this.$utils.unit2Tree(res.data)
                            const mergeData = this.$utils.bookAndUnit(books, units)
                            // 唯一值必须有规则 例如 1-1-2
                            let arr = this.$utils.setUniqueTree({data: mergeData})
                            if(arr && arr.length === 0) {
                                arr = [
                                    {
                                        key: 'all',
                                        value: '全部'
                                    }
                                ]
                            }
                            this.treeData = arr
                            this.newNavCatalogName = this.newForm[selectIndex].options.filter(v=>`${v.key}` === `${target}`)[0].value
                            this.setCurrentKey()
                            this.getCurrentKey()
                        } else {
                            this.treeData = this.tempKnowledge.filter(v=>{
                                return v.value.indexOf(this.newForm[selectIndex].value)>-1
                            })
                        }
                        break
                    }
                    case 'tree': {
                        if(this.isTeachArticle) {
                            this.newKnowledgeId = ''
                            this.newChapterId = target.data.key
                        } else {
                            this.newChapterId = ''
                            this.newKnowledgeId = target.data.id
                            this.newUnitName = target.data.value
                        }
                        break
                    }
                }
            },
            // 出版社选中
            async publisherSelected(pub_id, initial){
                const selectIndex = this.$utils.getIndexByAttr({attr: 'select', data: this.newForm})
                if (!pub_id) {
                    // this.newForm[treeIndex].props.data = []
                    this.treeData = []
                    this.newChapterId = ''
                    this.newCatalogId = ''
                    return false
                }
                this.newCatalogId = pub_id
                // 获取书名列表
                const booksList = await CommonServer.default.queryBooks({
                    subject_id: this.subject_id,
                    grade_id: this.grade_id,
                    publisher_id: pub_id
                })
                const books = booksList.data.map(v=>{
                    return {
                        key: `${v.id}`,
                        value: v.book_name,
                        children: []
                    }
                })
                // this.treeData = arr
                // console.log(booksList)
                // debugger
                const res = await CommonServer.default.queryUnits({
                    subject_id: this.subject_id,
                    pub_id,
                    with_chapters: 1 // 是否加载章节
                })
                // 1.重新组装单元节点 章节+单元
                // 2.将章节和单元 挂在书籍下面
                // 3.给整颗数每个节点设置唯一值
                const units = this.$utils.unit2Tree(res.data)
                const mergeData = this.$utils.bookAndUnit(books, units)
                // 唯一值必须有规则 例如 1-1-2
                let arr = this.$utils.setUniqueTree({data: mergeData})

                // 如果列表无数据，则默认存在一个全部选项
                if(arr && arr.length === 0){
                    arr = [
                        {
                            key: 'all',
                            value: '全部'
                        }
                    ]
                }

                this.treeData = arr
                this.newNavCatalogName = this.newForm[selectIndex].options.filter(v=>`${v.key}` === `${pub_id}`)[0].value
                if(!initial) this.newUnitName = ''
                this.setCurrentKey()
                this.getCurrentKey()
            },
            // 筛选知识点
            knowledgeInput(value){
                this.onAttr({attr: 'select'},value)
            },
            handleNodeClick(data){
                console.log('handleNodeClick==>1', data)
                if(data.children && data.children.length){
                    console.log('handleNodeClick==>2', data)
                    this.setCurrentKey(true)
                } else {
                    if(this.isTeachArticle) {
                        this.newChapterId = data.key.split('-')[0]
                    } else {
                        this.newKnowledgeId = data.key
                        this.newUnitName = data.value
                        return false
                    }
                    const arr = this.getParentNode(this.treeData, data.key)

                    console.log('parentsNode==>', arr)
                    // 1.选中菜单-对应的所有父级节点
                    this.newUnitSelectedParents = arr
                    this.newUnitName = arr.map(v=>v.value).join('/')
                }
            },
            setCurrentKey(initial){
                let key = ''
                let parents = this.newUnitSelectedParents
                if(parents && parents.length){
                    key = parents[parents.length - 1].key
                }
                const id = this.isTeachArticle?key:this.newKnowledgeId
                const newId = `${id}` || ''
                console.log('setCurrentKey==>', this.$refs.tree, newId)
                if(this.isTeachArticle){
                    // this.newChapterId = newId
                }
                const fn = setImmediate(()=>{
                   this.setNewKey(newId, initial)
                     clearImmediate(fn)
                })
            },
            // 设置选中目录 如果intial为true，设置不刷新
            setNewKey(key, initial){
                console.log('key==>', key)
                if(initial && key){
                    this.$refs.tree && this.$refs.tree.setCurrentKey(key)
                } else if(key){
                    this.$refs.tree && this.$refs.tree.setCurrentKey(key)
                    this.$emit('flashData')
                } else {this.$refs.tree && this.$refs.tree.setCurrentKey(null)
                }
            },
            getCurrentKey(){
                // const fn = setTimeout(()=>{
                //     const value = this.$refs.tree && this.$refs.tree.getCurrentKey()
                //     if(!value || JSON.stringify(this.treeData).indexOf(value) === -1){
                //         this.newUnitName = ''
                //     }
                //     clearTimeout(fn)
                // }, 500)
            },
            onFocus(item, target, index){
                console.log('onFocus==>', item, target, index)
                this.setSendKeyBoardToCocos({key: `onAttr${item.type}`, value: false})
            },
            onBlur(item, target, index){
                console.log('onBlur==>', item, target, index)
                this.setSendKeyBoardToCocos({key: `onAttr${item.type}`, value: true})
            },
            handleShow(){
                this.newIsArticleCatalog = !this.newIsArticleCatalog
            },
            clearNavAll(){
                console.log('333==>', !this.isTeachArticle)
                if(!this.isTeachArticle){
                    this.newKnowledgeId = ''
                    // this.setCurrentKey()
                } else {
                    this.newCatalogId = ''
                    this.newChapterId = ''
                    // this.newUnitName = ''
                }
            },
            curClearAll(){
                console.log('444==>')
                if(!this.isTeachArticle){
                    this.newKnowledgeId = ''
                    this.setNewKey(null)
                } else {
                    this.newUnitSelectedParents = []
                    this.newChapterId = ''
                    this.setNewKey(null)
                    this.newUnitName = ''
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.article-catalog /deep/ .el-form-item__content {
    width: 100%;
}
.txts{width: 100%;}
.txts /deep/ .component{
    width: calc(100% - 32px);
    padding-left: 16px;
    padding-right: 16px;
}
.txts /deep/ .component+.component{
    width: 100%;
    padding: 0px;
}
.txts /deep/ .component .item{
    padding-left: 0px;
}
.txts /deep/ .el-tree-node__content{
    height: 36px;
}
.article-catalog{
    display: flex;
    flex-direction: column;
    background-color: #DCDFE6;
    height: 100vh;
    position: relative;

    .warn{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-align: center;
        line-height: 50px;
        background: #FEF6E7;
        font-size: 14px;
        font-weight: 400;
        color: #303133;
        margin-left: 3px;
        margin-right: 3px;

        &>span{
            color: #FAAD14;
            margin-right: 4px;
            font-size: 16px;
        }
    }

    .btn-menu{
        position: absolute;
        top: 6px;
        left: -34px;
        background-color: #303133;
        width: 34px;
        height: 32px;
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .icon-caidan1{
            color: white;
            font-size: 14px;
            position: relative;
            left: 2px;
        }
    }

    .title-box{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .title{
            font-size: 16px;
            font-weight: 400;
            color: #303133;
            line-height: 22px;
            margin-left: 16px;
            margin-top: 14px;
            margin-bottom: 14px;
        }

        .el-icon-close{
            padding: 12px 18px;
            color: #303133;
            cursor: pointer;
            position: relative;

            &:hover{
                color: #e7622e;
            }
        }
    }
    .tree-box{
        font-size: 14px;
        padding: 20px 0px;
        display: flex;
        flex-direction: column;
        flex: 1;
        background-color: white;
        margin: 0px 3px;

        .opt-box{
            padding: 0px 16px 20px;

            & /deep/ .el-select{
                width: 100%;
            }
        }

        .tree{
            overflow-y: auto;
            max-height: calc(100vh - 185px)
        }
    }
    .tree-box /deep/ .el-tree-node__content{
        height: 36px;
    }
}
</style>
